// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-0f680062]::-webkit-scrollbar{width:4px;height:4px}[data-v-0f680062]::-webkit-scrollbar-track{background:transparent}[data-v-0f680062]::-webkit-scrollbar-thumb{background:#e2e8f0;border-radius:10px}[data-v-0f680062]::-webkit-scrollbar-thumb:hover{background:#cbd5e1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
